import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}
import { inject, onMounted, onUnmounted, ref } from "vue";
import { BFormInput } from "bootstrap-vue-next";
import CategorySelection from "./../CategorySelection/index.ts";
import CourseIndex from "./../CourseIndex/index.ts";
import Checkout from "../Checkout/index.ts";
import Login from "./../Login/index.ts";
import Videos from "../Videos/index.ts";
import LoginReturn from "../LoginReturn/index.ts";
import type { UserService } from "../../application/services/UserService.ts";
export default {
  template: html,
  components: {
    CourseIndex,
    Login,
    LoginReturn,
    Checkout,
    Videos,
    CategorySelection,
    BFormInput,
  },
  setup() {
    const error = ref("");
    const view = ref("CourseIndex");
    const courseSearch = ref("");
    const categoryId = ref(0);
    const courseId = ref(0);
    const isLoggedIn = ref(false);
    const userService: UserService | undefined = inject("userService");
    let heartbeatInterval: number | undefined;

    const onCheckoutAbort = function () {
      courseId.value = 0;
      view.value = "CourseIndex";
    };
    const resetCourseSearch = function () {
      courseSearch.value = "";
    };

    const gotoVideos = function () {
      view.value = "Video";
    };
    const goBackToCourses = function () {
      view.value = "CourseIndex";
    };
    const onBookCourseId = function (id: number) {
      courseId.value = id;
      view.value = "Checkout";
    };

    const onCategorySelected = function (id: number) {
      categoryId.value = id;
    };

    const updateLoggedInValue = async function () {
      if (userService) {
        try {
          isLoggedIn.value = await userService.isLoggedIn();
        } catch {
          isLoggedIn.value = false;
        }
      } else {
        isLoggedIn.value = false;
      }
    };

    onMounted(async function () {
      await updateLoggedInValue();
      heartbeatInterval = window.setInterval(updateLoggedInValue, 60000);
    });
    onUnmounted(() => {
      if (heartbeatInterval) {
        clearInterval(heartbeatInterval);
      }
    });

    return {
      error,
      courseSearch,
      gotoVideos,
      onCheckoutAbort,
      resetCourseSearch,
      onCategorySelected,
      onBookCourseId,
      goBackToCourses,
      categoryId,
      courseId,
      isLoggedIn,
      view,
    };
  },
};
